import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NotFoundInterceptor implements HttpInterceptor {
  constructor(private readonly router: Router) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const result = next.handle(req);

    return result.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404 && /\/\d+/.test(this.router.url)) {
          this.router.navigate(['/']);
        }
        return throwError(() => error);
      })
    );
  }
}
